import { backToParent } from '../../_utils/navTrail';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import useWindowSize from '../new-service/useWindowSize';
import NotificationBell from '../notifications/NotificationBell';
import LocationPicker from '../multiLocation/LocationPicker';
import './SettingsTopNav.css';

const BackArrowIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="19" y1="12" x2="5" y2="12" />
        <polyline points="12 19 5 12 12 5" />
    </svg>
);

export const tabIcons = {
    'onboarding': (
        // Replay arrow: this page restarts the first-login flow.
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 12a9 9 0 1 0 3-6.7" />
            <path d="M3 4v5h5" />
        </svg>
    ),
    'finish-setup': (
        // Checklist: the jobs left to do.
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 6h11M9 12h11M9 18h11" />
            <path d="M3.5 6l1.2 1.2L7 5M3.5 12l1.2 1.2L7 11" />
            <circle cx="5" cy="18" r="1.2" />
        </svg>
    ),
    'diary-demo': (
        // Calendar with filled blocks: a busy demo day.
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="4.5" width="18" height="16" rx="3" />
            <path d="M3 9.5h18M8 2.5v4M16 2.5v4" />
            <path d="M7 13h4M13 16.5h4" />
        </svg>
    ),
    'savings-calculator': (
        // A coin and an upward arrow: money back.
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="9" cy="14" r="6" />
            <path d="M10.5 11.8c-.4-.5-1-.8-1.7-.8-1 0-1.8.6-1.8 1.4 0 1.9 3.6 1.1 3.6 3 0 .8-.8 1.4-1.8 1.4-.7 0-1.4-.3-1.8-.8M9 10v1M9 17v1" />
            <path d="M16 9l4-4M16.5 5H20v3.5" />
        </svg>
    ),
    'bailey-welcome': (
        // Sparkle: the welcome's first minute.
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
            <path d="M19 16l.7 1.8 1.8.7-1.8.7L19 21l-.7-1.8-1.8-.7 1.8-.7z" />
        </svg>
    ),
    'payout-account': (
        // Bank building: distinct from the card on Payments.
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9l9-5 9 5H3z" />
            <path d="M5 9v8M10 9v8M14 9v8M19 9v8" />
            <path d="M3 20h18" />
        </svg>
    ),
    'card-reader': (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="5" width="20" height="14" rx="2" />
            <line x1="2" y1="10" x2="22" y2="10" />
        </svg>
    ),
    'salon-details': (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
    ),
    'booking-url': (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
    ),
    'billing': (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
        </svg>
    ),
    'diary-sharing': (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
            <circle cx="8" cy="15" r="1" fill="currentColor" />
            <path d="M11 15h6" />
        </svg>
    ),
    'notifications': (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
    ),
    'locations': (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 21s7-6.5 7-11.5a7 7 0 0 0-14 0C5 14.5 12 21 12 21z" />
            <circle cx="12" cy="9.5" r="2.5" />
        </svg>
    ),
    'ai-assistant': (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            <circle cx="9" cy="10" r="1" fill="currentColor" />
            <circle cx="15" cy="10" r="1" fill="currentColor" />
        </svg>
    ),
    'your-choices': (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2l7 3v6c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V5l7-3z" />
            <path d="M9 12l2 2 4-4" />
        </svg>
    ),
    'business-numbers': (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.04 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
    ),
    // A lock: reception mode locks a shared front-desk device.
    'reception-mode': (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="4" y="11" width="16" height="10" rx="2" />
            <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        </svg>
    ),
};

function SettingsTopNav({ activeTab, tabs, onTabChange, children, history }) {
    const { width } = useWindowSize();
    const isMobile = width <= 1100;

    const getCurrentTitle = () => {
        if (!tabs) return 'Settings';
        const item = tabs.find(n => n.id === activeTab);
        return item ? item.label : 'Settings';
    };

    if (isMobile) {
        return (
            <div className="catalogue-mobile-header">
                <button className="catalogue-mobile-back-btn" onClick={() => backToParent(history, '/settings')}>
                    <BackArrowIcon />
                </button>
                <h1 className="catalogue-mobile-title">{getCurrentTitle()}</h1>
                <div className="catalogue-mobile-actions">
                    <LocationPicker slot="mobile" />
                    {children}
                </div>
            </div>
        );
    }

    // Desktop: no tab strip any more, the hub (/settings) is the menu. A
    // sub-page gets a slim bar: back to All settings, the page title, the
    // page's own actions and the bell. The hub keeps just the bell.
    const onHub = activeTab === 'hub';
    return (
        <div className={`catalogue-top-nav settings-topbar${onHub ? ' settings-topbar--hub' : ''}`}>
            <div className="catalogue-top-nav-container">
                <div className="catalogue-top-nav-content">
                    {!onHub && (
                        <>
                            <button
                                type="button"
                                className="catalogue-tab-btn settings-tab-all"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => backToParent(history, '/settings')}
                                aria-label="All settings"
                            >
                                <BackArrowIcon />
                                <span>All settings</span>
                            </button>
                            <h2 className="settings-topbar-title">{getCurrentTitle()}</h2>
                        </>
                    )}
                    <div className="catalogue-nav-actions">
                        {children}
                    </div>
                </div>
            </div>
            <div className="notif-bell-pinned-wrap">
                <LocationPicker />
                <NotificationBell />
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return { ...state };
}

export default withRouter(connect(mapStateToProps)(SettingsTopNav));
